import { render, staticRenderFns } from "./floorMng.vue?vue&type=template&id=2a4024be&scoped=true"
import script from "./floorMng.vue?vue&type=script&lang=js"
export * from "./floorMng.vue?vue&type=script&lang=js"
import style0 from "./floorMng.vue?vue&type=style&index=0&id=2a4024be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4024be",
  null
  
)

export default component.exports